import React from 'react';
import {Page, ContainerLeft} from 'components/layouts';
import {Heading, Text, media} from 'components/styled';
import styled from 'styled-components';
import {contactLocalization} from "../../localization";

const PrivacyPolicy = (props) => {

    const {
        email1,
    } = contactLocalization.en;



    return (
        <Page>
            <ContainerLeft>
                <div className="main-title">Privacy Policy</div>
                <Content>
                    <Text>Effective date: July 24, 2018</Text>

                    <Text>
                        Infrastructure Monitoring ("us", "we", or "our") operates the
                        website and the Infrastructure Monitoring mobile application (the
                        "Service").
                    </Text>

                    <Text>
                        This page informs you of our policies regarding the collection, use,
                        and disclosure of personal data when you use our Service and the
                        choices you have associated with that data.
                    </Text>

                    <Text>
                        We use your data to provide and improve the Service. By using the
                        Service, you agree to the collection and use of information in
                        accordance with this policy. Unless otherwise defined in this
                        Privacy Policy, terms used in this Privacy Policy have the same
                        meanings as in our Terms and Conditions.
                    </Text>

                    <Heading.h2>Information Collection And Use</Heading.h2>

                    <Text>
                        We collect several different types of information for various
                        purposes to provide and improve our Service to you.
                    </Text>

                    <Heading.h3>Types of Data Collected</Heading.h3>

                    <Heading.h4>Personal Data</Heading.h4>

                    <Text>
                        While using our Service, we may ask you to provide us with certain
                        personally identifiable information that can be used to contact or
                        identify you ("Personal Data"). Personally identifiable information
                        may include, but is not limited to: Email address, First name and
                        last name, Cookies and Usage Data.
                    </Text>

                    <Heading.h4>Usage Data</Heading.h4>

                    <Text>
                        We may also collect information that your browser sends whenever you
                        visit our Service or when you access the Service by or through a
                        mobile device ("Usage Data").
                    </Text>
                    <Text>
                        This Usage Data may include information such as your computer's
                        Internet Protocol address (e.g. IP address), browser type, browser
                        version, the pages of our Service that you visit, the time and date
                        of your visit, the time spent on those pages, unique device
                        identifiers and other diagnostic data.
                    </Text>
                    <Text>
                        When you access the Service by or through a mobile device, this
                        Usage Data may include information such as the type of mobile device
                        you use, your mobile device unique ID, the IP address of your mobile
                        device, your mobile operating system, the type of mobile Internet
                        browser you use, unique device identifiers and other diagnostic
                        data.
                    </Text>

                    <Heading.h4>Tracking & Cookies Data</Heading.h4>
                    <Text>
                        We use cookies and similar tracking technologies to track the
                        activity on our Service and hold certain information.
                    </Text>
                    <Text>
                        Cookies are files with small amount of data which may include an
                        anonymous unique identifier. Cookies are sent to your browser from a
                        website and stored on your device. Tracking technologies also used
                        are beacons, tags, and scripts to collect and track information and
                        to improve and analyze our Service.
                    </Text>
                    <Text>
                        You can instruct your browser to refuse all cookies or to indicate
                        when a cookie is being sent. However, if you do not accept cookies,
                        you may not be able to use some portions of our Service.
                    </Text>
                    <Text>Examples of Cookies we use:</Text>
                    <ul>
                        <li>
              <span>
                <strong>Session Cookies:</strong> We use Session Cookies to
                operate our Service.
              </span>
                        </li>
                        <li>
              <span>
                <strong>Preference Cookies:</strong> We use Preference Cookies
                to remember your preferences and various settings.
              </span>
                        </li>
                        <li>
              <span>
                <strong>Security Cookies:</strong> We use Security Cookies for
                security purposes.
              </span>
                        </li>
                    </ul>

                    <Heading.h2>Use of Data</Heading.h2>

                    <Text>
                        Infrastructure Monitoring uses the collected data for various
                        purposes:
                    </Text>
                    <ul>
                        <li>
                            <span>To provide and maintain the Service</span>
                        </li>
                        <li>
                            <span>To notify you about changes to our Service</span>
                        </li>
                        <li>
              <span>
                To allow you to participate in interactive features of our
                Service when you choose to do so
              </span>
                        </li>
                        <li>
                            <span>To provide customer care and support</span>
                        </li>
                        <li>
              <span>
                To provide analysis or valuable information so that we can
                improve the Service
              </span>
                        </li>
                        <li>
                            <span>To monitor the usage of the Service</span>
                        </li>
                        <li>
                            <span>To detect, prevent and address technical issues</span>
                        </li>
                    </ul>

                    <Heading.h2>Transfer of Data</Heading.h2>
                    <Text>
                        Your information, including Personal Data, may be transferred to —
                        and maintained on — computers located outside of your state,
                        province, country or other governmental jurisdiction where the data
                        protection laws may differ than those from your jurisdiction.
                    </Text>
                    <Text>
                        If you are located outside Nepal and choose to provide information
                        to us, please note that we transfer the data, including Personal
                        Data, to Nepal and process it there.
                    </Text>
                    <Text>
                        Your consent to this Privacy Policy followed by your submission of
                        such information represents your agreement to that transfer.
                    </Text>
                    <Text>
                        Infrastructure Monitoring will take all steps reasonably necessary
                        to ensure that your data is treated securely and in accordance with
                        this Privacy Policy and no transfer of your Personal Data will take
                        place to an organization or a country unless there are adequate
                        controls in place including the security of your data and other
                        personal information.
                    </Text>

                    <Heading.h2>Disclosure Of Data</Heading.h2>

                    <Heading.h3>Legal Requirements</Heading.h3>
                    <Text>
                        Infrastructure Monitoring may disclose your Personal Data in the
                        good faith belief that such action is necessary to:
                    </Text>
                    <ul>
                        <li>
                            <span>To comply with a legal obligation</span>
                        </li>
                        <li>
              <span>
                To protect and defend the rights or property of Infrastructure
                Monitoring
              </span>
                        </li>
                        <li>
              <span>
                To prevent or investigate possible wrongdoing in connection with
                the Service
              </span>
                        </li>
                        <li>
              <span>
                To protect the personal safety of users of the Service or the
                public
              </span>
                        </li>
                        <li>
                            <span>To protect against legal liability</span>
                        </li>
                    </ul>

                    <Heading.h2>Security Of Data</Heading.h2>
                    <Text>
                        The security of your data is important to us, but remember that no
                        method of transmission over the Internet, or method of electronic
                        storage is 100% secure. While we strive to use commercially
                        acceptable means to protect your Personal Data, we cannot guarantee
                        its absolute security.
                    </Text>

                    <Heading.h2>Service Providers</Heading.h2>
                    <Text>
                        We may employ third party companies and individuals to facilitate
                        our Service ("Service Providers"), to provide the Service on our
                        behalf, to perform Service-related services or to assist us in
                        analyzing how our Service is used.
                    </Text>
                    <Text>
                        These third parties have access to your Personal Data only to
                        perform these tasks on our behalf and are obligated not to disclose
                        or use it for any other purpose.
                    </Text>

                    <Heading.h2>Links To Other Sites</Heading.h2>
                    <Text>
                        Our Service may contain links to other sites that are not operated
                        by us. If you click on a third party link, you will be directed to
                        that third party's site. We strongly advise you to review the
                        Privacy Policy of every site you visit.
                    </Text>
                    <Text>
                        We have no control over and assume no responsibility for the
                        content, privacy policies or practices of any third party sites or
                        services.
                    </Text>

                    <Heading.h2>Children's Privacy</Heading.h2>
                    <Text>
                        Our Service does not address anyone under the age of 18
                        ("Children").
                    </Text>
                    <Text>
                        We do not knowingly collect personally identifiable information from
                        anyone under the age of 18. If you are a parent or guardian and you
                        are aware that your Children has provided us with Personal Data,
                        please contact us. If we become aware that we have collected
                        Personal Data from children without verification of parental
                        consent, we take steps to remove that information from our servers.
                    </Text>

                    <h2>Changes To This Privacy Policy</h2>
                    <Text>
                        We may update our Privacy Policy from time to time. We will notify
                        you of any changes by posting the new Privacy Policy on this page.
                    </Text>
                    <Text>
                        We will let you know via email and/or a prominent notice on our
                        Service, prior to the change becoming effective and update the
                        "effective date" at the top of this Privacy Policy.
                    </Text>
                    <Text>
                        You are advised to review this Privacy Policy periodically for any
                        changes. Changes to this Privacy Policy are effective when they are
                        posted on this page.
                    </Text>

                    <Heading.h2>Contact Us</Heading.h2>
                    <Text>
                        If you have any questions about this Privacy Policy, please contact
                        us at
                          <a href={'mailto:' + email1}>{ ' ' + email1}</a>
                    </Text>
                </Content>
            </ContainerLeft>
        </Page>
    );
};

const Content = styled.div`
  margin-top: 40px;
  ${media.tablet`width: 70%;`};
  ${media.tabletWide`width: 50%;`};
  h2 {
    font-size: ${props => (props.lang === 'en' ? '18px' : '20px')};
    margin-bottom: 4px;
  }
  h3 {
    font-size: ${props => (props.lang === 'en' ? '16px' : '18px')};
    margin-bottom: 4px;
  }
  h4 {
    font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
    margin: 20px 0 4px;
  }
  p,
  ul {
    font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
    line-height: 1.5;
    margin-bottom: 20px;
    & + h2,
    & + h3,
    & + h4 {
      margin-top: 40px;
    }
  }
  a {
    color: ${props => props.theme.primary.pissYellow};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  ul {
    li {
      margin-bottom: 4px;
      position: relative;
      &:before {
        content: '';
        background-color: ${props => props.theme.primary.pissYellow};
        border-radius: 50%;
        display: inline-block;
        height: 6px;
        margin-top: 10px;
        margin-right: 10px;
        vertical-align: top;
        width: 6px;
      }
      span {
        display: inline-block;
        width: calc(100% - 18px);
      }
    }
  }
`;

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/pages/privacyPolicy/privacyPolicy.js